import { Button } from 'antd';
import message from '@web-common/components/UI/Message/SiriusMessage';
import classNames from 'classnames';
import React, { useState } from 'react';
import styles from './empty.module.scss';
import { getIn18Text } from 'api';
const ContactEmpty = ({ onRefresh, text, renderContent, imgClassName, className, style }) => {
    const [loading, setLoading] = useState(false);
    const handleRefresh = async () => {
        if (onRefresh) {
            setLoading(!0);
            const error = await onRefresh();
            setLoading(!!0);
            if (error) {
                message.error({
                    content: error,
                    duration: 1,
                });
            }
        }
    };
    const renderRefresh = () => {
        if (!onRefresh) {
            return null;
        }
        if (loading) {
            return React.createElement("span", { className: styles.emptyRefeshIcon });
        }
        return (React.createElement(Button, { type: "link", onClick: handleRefresh }, getIn18Text('SHUAXIN')));
    };
    return (React.createElement("div", { style: style, className: classNames(styles.emptyContainer, className) },
        React.createElement("div", { className: classNames('sirius-empty sirius-empty-search', styles.emptyImg, imgClassName) }),
        React.createElement("p", null, text),
        renderRefresh(),
        renderContent ? renderContent() : null));
};
export default ContactEmpty;
